<!-- <app-preloader></app-preloader> -->
<app-header></app-header>
<router-outlet></router-outlet>
<app-footer *ngIf="!(location == '/login' || location == '/register' || location == '/coming-soon')"></app-footer>